import React, { Component } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  RadioGroup,
  Radio,
  TextField,
  ToggleButton,
  Switch,
  Tooltip,
  IconButton,
} from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import "./CustomizePopup.css";
import { CheckBox } from "devextreme-react";
import { InfoOutlined, InfoRounded } from "@material-ui/icons";

class PopupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creative_cta: "With CTAs",
      creative_size: [],
      messaging_sparks: ["Rep", "Sample"],
      workflowWithAdds: [
        "Login",
        "Calendar/Waiting Room",
        "Patient chart",
        "Consultation",
        "Procedure",
        "Diagnosis",
        "Prescription",
      ],
    };
    const alreadyValues = localStorage.getItem("creativeConfig")
      ? JSON.parse(localStorage.getItem("creativeConfig"))
      : null;
    if (alreadyValues) {
      this.state = alreadyValues;
    }
  }

  handleOnChange = (event) => {
    const { name, value } = event.target;

    if (
      name === "creative_size" ||
      name === "messaging_sparks" ||
      name === "workflowWithAdds"
    ) {
      if (this.state[name].includes(value)) {
        return this.setState({
          [name]: this.state[name].filter((element) => element !== value),
        });
      } else {
        return this.setState({ [name]: [...this.state[name], value] });
      }
    }

    this.setState({ [name]: value });
  };

  render() {
    const { open, onClose, data } = this.props;
    const saveDetailsHandler = () => {
      localStorage.setItem("creativeConfig", JSON.stringify(this.state));
      onClose();
    };

    const creativeSizeOptions = [
      {
        value: "horizontal",
        label: "Leaderboard",
        subLabel: "728 x 90",
        imageSrc: "../../assets/ehrlogin/Heart.svg",
      },
      {
        value: "react",
        label: "Inline Rectangle",
        subLabel: "300 x 250",
        imageSrc: "../../assets/ehrlogin/Heart.svg",
      },
      {
        value: "vertical",
        label: "Half-Page Ad",
        subLabel: "300 x 600",
        imageSrc: "../../assets/ehrlogin/Heart.svg",
      },
    ];
    const sparksOptions = [
      { value: "Drug", imageSrc: "../../assets/ehrlogin/Heart.svg" },
      { value: "Copay", imageSrc: "../../assets/ehrlogin/Heart.svg" },
      { value: "Rep", imageSrc: "../../assets/ehrlogin/Heart.svg" },
      { value: "Sample", imageSrc: "../../assets/ehrlogin/Heart.svg" },
      { value: "Trial", imageSrc: "../../assets/ehrlogin/Heart.svg" },
    ];
    const workflowsOptions = [
      { value: "Login" },
      { value: "Calendar/Waiting Room" },
      { value: "Patient chart" },
      { value: "Consultation" },
      { value: "Procedure" },
      { value: "Diagnosis" },
      { value: "Prescription" },
    ];

    const { creative_cta, creative_size, messaging_sparks, workflowWithAdds } =
      this.state;

    console.log(this.state);

    return (
      <Dialog open={open} onClose={onClose} className="customisePopupSection">
        <DialogTitle className="popupHeader">
          Customzie your EHR demo platform
        </DialogTitle>
        <DialogContent>
          <form className="subCampaignForm">
            <div className="step-new-content pl-5 pr-5 pt-4 pb-4">
              <div className="form-group row mb-3">
                <label
                  htmlFor="chooseChannel"
                  className="col-sm-4 col-form-label formLabel"
                >
                  Creative CTAs
                  <i className="icon-78 tradMak fs12 grColor"></i>
                </label>
                <div className="col-sm-8">
                  <RadioGroup
                    name="creative_cta"
                    value={creative_cta}
                    onChange={this.handleOnChange}
                    className="flex-item"
                  >
                    <FormControlLabel
                      value="With CTAs"
                      checked={this.state.creative_cta === "With CTAs"}
                      control={<Radio className="pr-5" />}
                      label="With CTAs"
                      className="pr-15"
                    />
                    <FormControlLabel
                      value="Without CTAs"
                      checked={this.state.creative_cta === "Without CTAs"}
                      control={<Radio className="pr-5" />}
                      label="Without CTAs"
                      className="pr-15"
                    />
                  </RadioGroup>
                </div>
              </div>
              <div class="form-group row mb-2 pb-0 network-camp-type-radio-ui">
                <label
                  for="inputPassword"
                  class="col-sm-4 col-form-label formLabel"
                >
                  Creative Sizes
                  <i className="icon-78 tradMak fs12 grColor"></i>
                </label>
                <div class="col-sm-8">
                  <div class="row fs13 mb-2">
                    <CheckBox row className="campaignCheckbox">
                      {creativeSizeOptions.map((option, index) => (
                        <FormControlLabel
                          key={index}
                          name="creative_size"
                          value={option.value}
                          control={<Checkbox />}
                          onChange={this.handleOnChange}
                          className={
                            this.state.creative_size.includes(option.value)
                              ? "checkedBox":"uncheckedBox"
                      
                          }
                          label={
                            <div className="nav-link tac lh10 position-relative">
                              {/* <span className="mb-1">
                                <img
                                  alt={option.label}
                                  src={option.imageSrc}
                                  height="20"
                                  width={
                                    option.label === "Triggers" ? "24" : "22"
                                  }
                                />
                              </span> */}
                              <div className="outerdiv">
                                <div className="bannerSize">
                                  <div
                                    style={{
                                      width:
                                        option.value === "horizontal"
                                          ? 60
                                          : option.value === "vertical"
                                          ? 20
                                          : 30,
                                      height:
                                        option.value === "horizontal"
                                          ? 30
                                          : option.value === "vertical"
                                          ? 30
                                          : 20,
                                      margin: "10px 20px 10px 18px",
                                      backgroundColor: "rgb(218, 212, 212)",
                                    }}
                                  />
                                </div>
                                <div>
                                  <span className="spantag">
                                    {option.subLabel} <br />
                                    {option.label}
                                  </span>
                                </div>
                              </div>

                              {/* <span>{option.label}</span> */}
                            </div>
                          }
                        />
                      ))}
                    </CheckBox>
                  </div>
                </div>
              </div>
              <div class="form-group row mb-2 pb-0 network-camp-type-radio-ui">
                <label
                  for="inputPassword"
                  class="col-sm-4 col-form-label formLabel"
                >
                  Messaging Sparks
                  <i className="icon-78 tradMak fs12 grColor"></i>
                </label>
                <div class="col-sm-8">
                  <div class="row fs13  mb-2">
                    <CheckBox row className="campaignCheckbox sparksCheckbox">
                      {sparksOptions.map((option, index) => (
                        <FormControlLabel
                          key={index}
                          name="messaging_sparks"
                          value={option.value}
                          control={<Checkbox />}
                          onChange={this.handleOnChange}
                          label={
                            <div
                              className={
                                messaging_sparks.includes(option.value)
                                  ? "nav-link tac lh10 position-relative"
                                  : "uncheckedSparks tac lh10 position-relative"
                              }
                            >
                              <span className="mb-1">
                                <img
                                  alt={option.label}
                                  src={option.imageSrc}
                                  height="20"
                                  width={
                                    option.label === "Triggers" ? "24" : "22"
                                  }
                                />
                              </span>
                              <span>{option.value}</span>
                            </div>
                          }
                        />
                      ))}
                    </CheckBox>
                  </div>
                </div>
              </div>

              <div className="form-group row mb-2 pb-0 network-camp-type-radio-ui">
                <label
                  htmlFor="enableDisplayPlus"
                  className="col-sm-4 col-form-label formLabel"
                >
                  Workflows with Ads
                  <i className="icon-78 tradMak fs12 grColor"></i>
                </label>
                <div className="col-sm-8">
                  <div className="form-group workFlex ripple ">
                    {workflowsOptions.map((option, index) => (
                      <FormControlLabel
                        checked={this.state.workflowWithAdds.includes(
                          option.value
                        )}
                        key={index}
                        name="workflowWithAdds"
                        value={option.value}
                        control={<Checkbox />}
                        label={option.value}
                        onChange={this.handleOnChange}
                      />
                    ))}
                  </div>
                  {/* Additional content related to Display+ if needed */}
                </div>
              </div>
            </div>
          </form>
          <button className="popupsavebtn" onClick={saveDetailsHandler}>
            save
          </button>
        </DialogContent>
        {/* <button onClick={onClose} color="primary">
          close
        </button> */}
      </Dialog>
    );
  }
}

export default PopupComponent;
